import { lazy } from "react";

export const LandingFourthScreenAsync = lazy(() => import("./LandingFourthScreen"));
